import thumbnailIcon from "@assets/thumbnail/thumbnail.svg";
import { ARTICLE_REDESIGN } from "@helper/getEnvVariables";

export type ArticleCarouselFooterProps = {
  caption: string;
  credit: string;
};

export default function ArticleCarouselFooter({
  caption,
  credit,
}: ArticleCarouselFooterProps) {
  const newDesign = parseInt(ARTICLE_REDESIGN) === 1;
  return (
    <div
      className={`${newDesign ? "bg-white-200 p-[10px]" : "bg-blue-100 p-2"} inline-flex gap-2 items-center w-full`}
    >
      {!newDesign && (
        <img
          src={thumbnailIcon}
          height={15}
          width={15}
          alt="thumbnail icon"
          className="self-start mt-1"
        />
      )}
      <span
        className={`${newDesign ? "text-black-800 font-primary text-xxs leading-[150%]" : "text-white-100 font-primaryLight text-xs"} w-full font-regular`}
      >
        {`${caption} - `} <span className="font-medium">{credit}</span>
      </span>
    </div>
  );
}
